import { useState, type RefObject } from "react";
import { Type } from "lucide-react";
import RichTextEditor from "@/components/common/RichTextEditor";
import { MESSAGE_TEXT_MAX, messagePlain, plainToMessageHtml } from "@/lib/messageBody";
import "./MessageField.css";

export default function MessageField({
  id,
  label,
  value,
  onChange,
  placeholder,
  disabled,
  textareaRef,
}: {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  textareaRef?: RefObject<HTMLTextAreaElement>;
}) {
  const [rich, setRich] = useState(false);

  return (
    <div className="al-msg-field">
      <div className="al-msg-field-head">
        <label htmlFor={rich ? undefined : id}>{label}</label>
        <button
          type="button"
          className={`al-msg-mode${rich ? " is-on" : ""}`}
          aria-pressed={rich}
          aria-label={rich ? "Use plain text" : "Use rich text"}
          title={rich ? "Plain text" : "Rich text"}
          disabled={disabled}
          onClick={() => {
            if (rich) {
              onChange(messagePlain(value));
              setRich(false);
              return;
            }
            onChange(plainToMessageHtml(value));
            setRich(true);
          }}
        >
          <Type size={14} strokeWidth={2.25} aria-hidden />
        </button>
      </div>
      {rich ? (
        <RichTextEditor
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          minHeight="5.5rem"
          disabled={disabled}
          preview={false}
        />
      ) : (
        <textarea
          id={id}
          ref={textareaRef}
          value={value}
          maxLength={MESSAGE_TEXT_MAX}
          disabled={disabled}
          onChange={(event) => onChange(event.target.value)}
          placeholder={placeholder}
        />
      )}
    </div>
  );
}
